// Shared wire/storage contract with web-core src/lib/main/contractType.
export const GUEST_CONTRACT_TYPE_KEY = "nzsc_guest_contract_type_v1";
const TOKEN_KEY = "naezip_to_ac_se";
const LOCK_KEY = "nzsc-contract-type-migration";

export function createContractTypeMigrator({ storage, put, track, withLock = fn => fn() }) {
  let pending = null;
  let retryAfter = 0;
  let retryToken = null;
  const run = async () => {
    const token = storage.getItem(TOKEN_KEY);
    const raw = storage.getItem(GUEST_CONTRACT_TYPE_KEY);
    if (!token || !raw || (retryToken === token && Date.now() < retryAfter)) return false;
    let guest;
    try { guest = JSON.parse(raw); } catch { return false; }
    if (!guest || !["rent", "buy"].includes(guest.contract_type) ||
        typeof guest.selected_date !== "string" || !Number.isFinite(Date.parse(guest.selected_date))) return false;
    const result = await put({ contract_type: guest.contract_type, selected_date: guest.selected_date, only_if_empty: true }, token);
    if (storage.getItem(GUEST_CONTRACT_TYPE_KEY) !== raw) return false;
    if (!result || !["rent", "buy"].includes(result.contract_type) ||
        !Number.isFinite(Date.parse(result.selected_date)) || typeof result.migrated !== "boolean") {
      retryToken = token;
      retryAfter = Date.now() + 30000;
      return false;
    }
    // Consume only this anonymous choice so a second account cannot inherit it.
    storage.removeItem(GUEST_CONTRACT_TYPE_KEY);
    retryAfter = 0;
    try { if (storage.getItem(TOKEN_KEY) === token) track({ migrated: result.migrated }); } catch { /* optional telemetry */ }
    return true;
  };
  return () => {
    if (!pending) {
      pending = Promise.resolve().then(() => withLock(run)).catch(() => false).finally(() => { pending = null; });
    }
    return pending;
  };
}

export function migrationLock(fn) {
  return typeof navigator !== "undefined" && navigator.locks
    ? navigator.locks.request(LOCK_KEY, { ifAvailable: true }, lock => lock ? fn() : false)
    : fn();
}
